/* tslint:disable */
/* eslint-disable */

export interface ShowScoreDetailDto {
    showId?: number | null;
    points?: number | null;
    calc?: number | null;
    showName?: string | null;
    showDate?: string | null;
    examId?: number | null;
    examName?: string | null;
}

export interface ShowScoreEntryDto {
    id?: number | null;
    place?: number | null;
    totalScore?: number | null;
    showId?: number | null;
    horseName?: string | null;
    horseRegisterId?: string | null;
    horseBreed?: string | null;
    riderFirstName?: string | null;
    riderLastName?: string | null;
    riderRegisterId?: string | null;
    scoringType?: number | null;
    startNo?: number | null;
    details?: ShowScoreDetailDto[] | null;
    /* Turnierwertung (scores-Endpunkt): Einzelpunkte als flache Arrays */
    p?: number[] | null;
    pCalc?: number[] | null;
    pId?: (number | null)[] | null;
    pName?: (string | null)[] | null;
}

export function ShowScoreDetailDtoFromJSON(json: any): ShowScoreDetailDto {
    if (json == null) return json;
    return {
        showId: json['showId'],
        points: json['points'],
        calc: json['calc'],
        showName: json['showName'],
        showDate: json['showDate'],
        examId: json['examId'],
        examName: json['examName'],
    };
}

export function ShowScoreEntryDtoFromJSON(json: any): ShowScoreEntryDto {
    if (json == null) return json;
    return {
        id: json['id'],
        place: json['place'],
        totalScore: json['points'] ?? json['totalScore'],
        showId: json['showId'],
        horseName: json['horseName'],
        horseRegisterId: json['horseRegisterId'],
        horseBreed: json['breed'],
        riderFirstName: json['riderFirstName'],
        riderLastName: json['riderLastName'],
        riderRegisterId: json['riderRegisterId'],
        scoringType: json['scoringType'],
        startNo: json['startNo'],
        details: Array.isArray(json['details']) ? json['details'].map(ShowScoreDetailDtoFromJSON) : null,
        p: json['p'],
        pCalc: json['pcalc'],
        pId: json['pId'],
        pName: json['pName'],
    };
}
